import React from 'react';
import './../App.css';
import GoodBlock from '../Components/GoodBlock'
import ScrollAnimation from 'react-animate-on-scroll';
import MethodsTwoContext from './../Contexts/MethodsTwo';
import axios from './../Api/MainApi';


export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      topics:[]
    }
    console.log(this.props.history.location.pathname);
  }
  
  componentDidMount(){
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    this.getAllTopics();
  }

  state = {
    topics:[]
  }

  static contextType = MethodsTwoContext;

  getAllTopics(){
    axios.get(`rest/GetAllTopic`,
    {
      headers: {
        Authorization: this.context.authorizationInfo.state.accessToken
      },

    })
    .then(Response => {
      console.log(Response.data)
      this.setState({topics:Response.data});
    })
    .catch(err => {
      console.log(err)
    })
  }

  render() {
    let detailList = this.state.detailList;
    let editId = this.state.editId;
    return (

      <>
                <div class="header_section">
                {/* <ScrollAnimation animateIn="fadeIn"> */}
                <div class="co-padding gray_bg">
                    <div class="box container">
                      <div class="multibox-head">
                        <ul class="multibox-head__list">
                          <li class="active">
                            <a href="#">جدیدترین مقالات </a>
                          </li> 
                          {/* <li class="">
                            <a href="#">دوره&zwnj;های پیشنهادی</a>
                          </li> */}
                        </ul> 
                        {/* <a href="/series" class="btn-more">مشاهده همه دوره&zwnj;ها</a> */}
                      </div> 
                      <div class="box_section ">
                                        {this.state.topics.map((e, key) => {
                                              return  ( <>
                                              {e.active ? 
                                              <GoodBlock
                                              key = {key}
                                              title={e.titleone} 
                                              description={e.titletwo}
                                              pageUrl = {'/articles/'+ e.pageurl}
                                              price=""
                                              imageAddress= {e.imageurl}/> 
                                              : <></>}
                                              </> )
                                              // imageAddress= {require(e.imageurl)}/>  
                                        })} 
                        </div>
                      </div>
                    </div>
                {/* </ScrollAnimation> */}
                </div>
         

      </>
    )
  }
}


